import { FC, lazy, useMemo } from 'react';
import { ContactsParams } from 'src/apis/organisation-service/types';
import { PageSpinner } from 'src/components/spinner-container';
import { Successful } from 'src/hooks/use-axios';
import { useOrganisationDetails } from 'src/pages/settings/organisation/company-information/use-organisation-details';
import { useContacts } from 'src/pages/settings/organisation/contacts/use-contacts';
import { usePageParams } from 'src/pages/settings/organisation/contacts/use-page-params';
import { OrganisationServiceRequest } from 'src/pages/settings/organisation/use-organisation-service';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

type Props = {
  organisationService: Successful<OrganisationServiceRequest>;
};

export const CreateContact: FC<Props> = ({ organisationService }) => {
  if (!organisationService.response.data._links.getMyOrganisationDetails)
    throw new Forbidden();

  const organisationDetails = useOrganisationDetails({
    url: organisationService.response.data._links.getMyOrganisationDetails.href,
  });

  if (!organisationDetails.response) return <PageSpinner />;

  return (
    <CreateContactPage
      contactLink={organisationDetails.response.data._links.contacts?.href}
    />
  );
};

const CreateContactPage: FC<{ contactLink?: string | null }> = ({
  contactLink,
}) => {
  if (!contactLink) throw new Forbidden();

  const pageParams = usePageParams();

  const params = useMemo(
    () =>
      ({
        limit: pageParams.value.pageSize,
        offset: pageParams.value.start,
      }) satisfies ContactsParams,
    [pageParams.value]
  );

  const contacts = useContacts({
    url: contactLink,
    params,
  });

  if (!contacts.response) return <PageSpinner />;

  return <Page contacts={contacts} />;
};
